import { render } from "./NotesModal.vue?vue&type=template&id=b591c884&scoped=true"
import script from "./NotesModal.vue?vue&type=script&lang=js"
export * from "./NotesModal.vue?vue&type=script&lang=js"

import "./NotesModal.vue?vue&type=style&index=0&id=b591c884&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b591c884"

export default script